import React, { Component } from "react";
import { profile, branch, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon, Swal, Pagination, Switch, Navbar, Modal, Resizer } from "../../../components/CustomComponent.js";
export default class Customers extends Component {
  constructor(props) {
      super(props);
      this.state = {
        modal_create: false,
        modal_update: false,
  
        filter_search: "",
  
        data: [],
        count: 10,
      };
    }
  
    async componentDidMount() {
      loading(false);
      await this.Get(1);
    }
    Get = async (page) => {
      let data, count;
      loading(true);
      let [result] = await Promise.all([GET("admin/setting/customers/list", { page: page, data_search: this.state.filter_search })]);
      if (result?.status) {
        data = result.data;
        count = result.count;
      }
      this.setState({
        data,
        count
      });
      loading(false);
    };
    Delete = async (id) => {
      if (await alert("", "warning", "ลบข้อมูล", "ยืนยันการลบรายการนี้หรือไม่ ?", "ลบข้อมูล", "ยกเลิก")) {
        loading(true);
        let result = await DELETE("admin/setting/customers/delete/" + id, null);
        if (result?.status) {
          alert("#", "success");
        }
        loading(false);
      }
    };
    render() {
      const { modal_create, modal_update, filter_search, data, count } = this.state;
      return (
        <div className="w-100 min-vh-100">
          <Navbar />
          <div className="body p-3">
            <div className="rounded-4 bg-white p-3">
              <div className="d-flex justify-content-between">
                <h4 className="fw-bold mb-3 me-3">ลูกค้า</h4>
                <button
                  className="btn btn-dark px-3 ms-auto mb-2 customers.create"
                  onClick={async () => {
                    window.location.href="/setting/customers/create"
                  }}
                >
                  เพิ่มรายการ
                </button>
              </div>
              <div className="d-flex flex-wrap">
                <input
                  type="text"
                  className="form-control wpx-200 me-2 mb-2"
                  placeholder="ค้นหา..."
                  onChange={(e) => {
                    this.setState({ filter_search: e.target.value });
                  }}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      this.Get(1);
                    }
                  }}
                  value={filter_search}
                />
                <div className="d-flex">
                  <button
                    className="btn btn-dark px-3 me-2 mb-2"
                    onClick={() => {
                      this.Get(1);
                    }}
                  >
                    ค้นหา
                  </button>
                  <button
                    className="btn btn-outline-dark px-3 me-2 mb-2"
                    onClick={() => {
                      window.location.reload();
                    }}
                  >
                    ล้างค่า
                  </button>
                </div>
              </div>
              <div className="table-responsive">
                <table className="table rounded-3 overflow-hidden table-hover">
                  <thead>
                    <tr>
                      <td className="text-nowrap">ลำดับ</td>
                      <td className="text-nowrap">รหัสลูกค้า</td>
                      <td className="text-nowrap">ชื่อลูกค้า/ชื่อบริษัท</td>
                      <td className="text-nowrap">เบอร์โทร</td> 
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((item, index) => (
                      <tr>
                        <td className="text-nowrap">{index + 1}</td>
                        <td className="text-nowrap">{item.customer_code || "-"}</td>
                        <td className="text-nowrap">{item.full_name || "-"}</td>
                        <td className="text-nowrap">{item.phone || "-"}</td> 
                        <td className="text-center align-middle">
                          <div className="d-flex">
                            <BtnIcon
                              className="customers.update"
                              type="update"
                              onClick={() => {
                                window.location.href="/setting/customers/update?id="+item.uid
                              }}
                            />
                            <BtnIcon
                              className="customers.delete"
                              type="delete"
                              onClick={() => {
                                this.Delete(item.uid);
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
              <Pagination className="mb-3" count={Math.ceil(count / 10) || 1} showFirstButton showLastButton onChange={(_, page) => this.Get(page)} />
            </div>
          </div>
        </div>
      );
    }
  }
  